export enum SearchOverviewOrderColumn {
  search_term = 'search_term',
  count = 'count',
  last_searched = 'last_searched'
}

export enum ResultSelectEnum {
  NO_RESULT = 'NO_RESULT',
  RESULT = 'RESULT',
  ALL = 'ALL'
}
